package com.castly.admin.ui.icons

import androidx.compose.runtime.Composable

// ==========================================================================
// Navigation icons
// ==========================================================================

@Composable
fun IconHome(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z") })
        SvgElement("polyline", { attr("points", "9 22 9 12 15 12 15 22") })
    }
}

@Composable
fun IconHeadphones(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M3 18v-6a9 9 0 0 1 18 0v6") })
        SvgElement("path", { attr("d", "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z") })
    }
}

@Composable
fun IconBookOpen(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z") })
        SvgElement("path", { attr("d", "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z") })
    }
}

@Composable
fun IconUsers(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2") })
        SvgElement("circle", { attr("cx", "9"); attr("cy", "7"); attr("r", "4") })
        SvgElement("path", { attr("d", "M23 21v-2a4 4 0 0 0-3-3.87") })
        SvgElement("path", { attr("d", "M16 3.13a4 4 0 0 1 0 7.75") })
    }
}

@Composable
fun IconTag(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z") })
        SvgElement("line", { attr("x1", "7"); attr("y1", "7"); attr("x2", "7.01"); attr("y2", "7") })
    }
}

@Composable
fun IconLayout(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("rect", { attr("x", "3"); attr("y", "3"); attr("width", "18"); attr("height", "18"); attr("rx", "2"); attr("ry", "2") })
        SvgElement("line", { attr("x1", "3"); attr("y1", "9"); attr("x2", "21"); attr("y2", "9") })
        SvgElement("line", { attr("x1", "9"); attr("y1", "21"); attr("x2", "9"); attr("y2", "9") })
    }
}

@Composable
fun IconFileText(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z") })
        SvgElement("polyline", { attr("points", "14 2 14 8 20 8") })
        SvgElement("line", { attr("x1", "16"); attr("y1", "13"); attr("x2", "8"); attr("y2", "13") })
        SvgElement("line", { attr("x1", "16"); attr("y1", "17"); attr("x2", "8"); attr("y2", "17") })
        SvgElement("polyline", { attr("points", "10 9 9 9 8 9") })
    }
}

@Composable
fun IconBarChart(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("line", { attr("x1", "12"); attr("y1", "20"); attr("x2", "12"); attr("y2", "10") })
        SvgElement("line", { attr("x1", "18"); attr("y1", "20"); attr("x2", "18"); attr("y2", "4") })
        SvgElement("line", { attr("x1", "6"); attr("y1", "20"); attr("x2", "6"); attr("y2", "16") })
    }
}

@Composable
fun IconLogOut(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4") })
        SvgElement("polyline", { attr("points", "16 17 21 12 16 7") })
        SvgElement("line", { attr("x1", "21"); attr("y1", "12"); attr("x2", "9"); attr("y2", "12") })
    }
}

@Composable
fun IconEye(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z") })
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "3") })
    }
}

@Composable
fun IconSettings(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "3") })
        SvgElement("path", { attr("d", "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z") })
    }
}

@Composable
fun IconChevronRight(size: Int = 16, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("polyline", { attr("points", "9 18 15 12 9 6") })
    }
}

@Composable
fun IconChevronDown(size: Int = 16, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("polyline", { attr("points", "6 9 12 15 18 9") })
    }
}

@Composable
fun IconMenu(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("line", { attr("x1", "3"); attr("y1", "12"); attr("x2", "21"); attr("y2", "12") })
        SvgElement("line", { attr("x1", "3"); attr("y1", "6"); attr("x2", "21"); attr("y2", "6") })
        SvgElement("line", { attr("x1", "3"); attr("y1", "18"); attr("x2", "21"); attr("y2", "18") })
    }
}

@Composable
fun IconClock(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "10") })
        SvgElement("polyline", { attr("points", "12 6 12 12 16 14") })
    }
}

// ==========================================================================
// Action icons
// ==========================================================================

@Composable
fun IconEdit(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z") })
    }
}

@Composable
fun IconTrash(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("polyline", { attr("points", "3 6 5 6 21 6") })
        SvgElement("path", { attr("d", "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2") })
        SvgElement("line", { attr("x1", "10"); attr("y1", "11"); attr("x2", "10"); attr("y2", "17") })
        SvgElement("line", { attr("x1", "14"); attr("y1", "11"); attr("x2", "14"); attr("y2", "17") })
    }
}

@Composable
fun IconPlus(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("line", { attr("x1", "12"); attr("y1", "5"); attr("x2", "12"); attr("y2", "19") })
        SvgElement("line", { attr("x1", "5"); attr("y1", "12"); attr("x2", "19"); attr("y2", "12") })
    }
}

@Composable
fun IconX(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("line", { attr("x1", "18"); attr("y1", "6"); attr("x2", "6"); attr("y2", "18") })
        SvgElement("line", { attr("x1", "6"); attr("y1", "6"); attr("x2", "18"); attr("y2", "18") })
    }
}

@Composable
fun IconRefreshCw(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("polyline", { attr("points", "23 4 23 10 17 10") })
        SvgElement("polyline", { attr("points", "1 20 1 14 7 14") })
        SvgElement("path", { attr("d", "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15") })
    }
}

@Composable
fun IconUpload(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4") })
        SvgElement("polyline", { attr("points", "17 8 12 3 7 8") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "3"); attr("x2", "12"); attr("y2", "15") })
    }
}

@Composable
fun IconDownload(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4") })
        SvgElement("polyline", { attr("points", "7 10 12 15 17 10") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "15"); attr("x2", "12"); attr("y2", "3") })
    }
}

@Composable
fun IconCheck(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("polyline", { attr("points", "20 6 9 17 4 12") })
    }
}

@Composable
fun IconSearch(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "11"); attr("cy", "11"); attr("r", "8") })
        SvgElement("line", { attr("x1", "21"); attr("y1", "21"); attr("x2", "16.65"); attr("y2", "16.65") })
    }
}

// ==========================================================================
// Theme toggle icons
// ==========================================================================

@Composable
fun IconMoon(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z") })
    }
}

@Composable
fun IconSun(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "5") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "1"); attr("x2", "12"); attr("y2", "3") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "21"); attr("x2", "12"); attr("y2", "23") })
        SvgElement("line", { attr("x1", "4.22"); attr("y1", "4.22"); attr("x2", "5.64"); attr("y2", "5.64") })
        SvgElement("line", { attr("x1", "18.36"); attr("y1", "18.36"); attr("x2", "19.78"); attr("y2", "19.78") })
        SvgElement("line", { attr("x1", "1"); attr("y1", "12"); attr("x2", "3"); attr("y2", "12") })
        SvgElement("line", { attr("x1", "21"); attr("y1", "12"); attr("x2", "23"); attr("y2", "12") })
        SvgElement("line", { attr("x1", "4.22"); attr("y1", "19.78"); attr("x2", "5.64"); attr("y2", "18.36") })
        SvgElement("line", { attr("x1", "18.36"); attr("y1", "5.64"); attr("x2", "19.78"); attr("y2", "4.22") })
    }
}

// ==========================================================================
// Status icons
// ==========================================================================

@Composable
fun IconAlertCircle(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "10") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "8"); attr("x2", "12"); attr("y2", "12") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "16"); attr("x2", "12.01"); attr("y2", "16") })
    }
}

@Composable
fun IconCheckCircle(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M22 11.08V12a10 10 0 1 1-5.93-9.14") })
        SvgElement("polyline", { attr("points", "22 4 12 14.01 9 11.01") })
    }
}

@Composable
fun IconInfo(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "12"); attr("cy", "12"); attr("r", "10") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "16"); attr("x2", "12"); attr("y2", "12") })
        SvgElement("line", { attr("x1", "12"); attr("y1", "8"); attr("x2", "12.01"); attr("y2", "8") })
    }
}

// ==========================================================================
// Drag icon
// ==========================================================================

@Composable
fun IconGripVertical(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("circle", { attr("cx", "9"); attr("cy", "12"); attr("r", "1"); attr("fill", color) })
        SvgElement("circle", { attr("cx", "9"); attr("cy", "5"); attr("r", "1"); attr("fill", color) })
        SvgElement("circle", { attr("cx", "9"); attr("cy", "19"); attr("r", "1"); attr("fill", color) })
        SvgElement("circle", { attr("cx", "15"); attr("cy", "12"); attr("r", "1"); attr("fill", color) })
        SvgElement("circle", { attr("cx", "15"); attr("cy", "5"); attr("r", "1"); attr("fill", color) })
        SvgElement("circle", { attr("cx", "15"); attr("cy", "19"); attr("r", "1"); attr("fill", color) })
    }
}

// ==========================================================================
// Additional icons
// ==========================================================================

@Composable
fun IconExternalLink(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6") })
        SvgElement("polyline", { attr("points", "15 3 21 3 21 9") })
        SvgElement("line", { attr("x1", "10"); attr("y1", "14"); attr("x2", "21"); attr("y2", "3") })
    }
}

@Composable
fun IconCopy(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("rect", { attr("x", "9"); attr("y", "9"); attr("width", "13"); attr("height", "13"); attr("rx", "2"); attr("ry", "2") })
        SvgElement("path", { attr("d", "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1") })
    }
}

@Composable
fun IconRss(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("path", { attr("d", "M4 11a9 9 0 0 1 9 9") })
        SvgElement("path", { attr("d", "M4 4a16 16 0 0 1 16 16") })
        SvgElement("circle", { attr("cx", "5"); attr("cy", "19"); attr("r", "1") })
    }
}

@Composable
fun IconImage(size: Int = 20, color: String = "currentColor") {
    SvgIcon(size, color) {
        SvgElement("rect", { attr("x", "3"); attr("y", "3"); attr("width", "18"); attr("height", "18"); attr("rx", "2"); attr("ry", "2") })
        SvgElement("circle", { attr("cx", "8.5"); attr("cy", "8.5"); attr("r", "1.5") })
        SvgElement("polyline", { attr("points", "21 15 16 10 5 21") })
    }
}
